import React, { Fragment } from 'react';
import { Button, Header, Icon, Loader, Popup, Responsive, Segment, Tab, TabPane } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
// import { Random } from 'react-animated-text';
import { fetchMarks, fetchStudyType, fetchSPBAndDepartments } from '../../Lookups/util';
import StudentsWithGrades from './StudentsWithGrades';
import GradingCommitteeExam from './GradingCommitteeExam';
import StudentsWithoutGrades from './StudentsWithoutGrades';
import ExternalStudentGrades from './ExternalStudentGrades';
import { IconHeader } from '../../Assets/util/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export const fetchStudyPograms = (courseImplementationId) => axios.get(`professor/study-programs-by-course/${courseImplementationId}`);


export default class InputGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            gradedStudents: [],
            ungradedStudents: [],
            allUngradedStudents: [],
            marks: [],
            studyTypes: [],
            studyPrograms: [],
            course: '',

            activeIndex: 0,

            sortingOptions: [
                {
                    value: 'firstNameAsc',
                    key: 'firstNameAsc',
                    text: 'Sortiraj po imenu A-Ž'
                },
                {
                    value: 'firstNameDes',
                    key: 'firstNameDes',
                    text: 'Sortiraj po imenu Ž-A'
                },
                {
                    value: 'lastNameAsc',
                    key: 'lastNameAsc',
                    text: 'Sortiraj po prezimenu A-Ž'
                },
                {
                    value: 'lastNameDes',
                    key: 'lastNameDes',
                    text: 'Sortiraj po prezimenu Ž-A'
                }

            ],

            loaded: false,
            graded: false,
            finalizeCheck: false,

            totalPagesGraded: null,
            totalPagesUngraded: null
        };

        this.onFinalize = this.onFinalize.bind(this);
        this.getAllStudents = this.getAllStudents.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.getStudentsForGroupGrading = this.getStudentsForGroupGrading.bind(this);
        this.frontFilterData = this.frontFilterData.bind(this);
    }

    componentDidMount() {
        localStorage.setItem('postsPerPageTab0', '25');
        localStorage.setItem('postsPerPageTab1', '25');
        if (localStorage.getItem('gradedActivityName') === 'komisijski ispit') { return; }
        axios.all([fetchMarks(), fetchStudyType(), fetchStudyPograms(localStorage.getItem('courseImplementationId')), fetchSPBAndDepartments(localStorage.getItem('courseImplementationId'))])
            .then(axios.spread((markRes, studyTypeRes, StudyProgramsRes, SPBAndDepartmentsRes) => {
                const marks = markRes.data.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName),
                    passed: el.passed,
                    key_: el._key,
                    letter: el.letter
                }));

                const studyTypes = studyTypeRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: ((window.$locale !== 'bs' && el.translations.length) ? el.translations.find(e => e.language === window.$locale).displayName : el.displayName)
                }));

                const studyPrograms = SPBAndDepartmentsRes.data.studyProgramBasics.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name
                }));

                const departments = SPBAndDepartmentsRes.data.organizationalUnits.map(el => ({
                    key: el.id,
                    value: el.id,
                    text: el.name
                }));
                this.setState({
                    marks, studyTypes, studyPrograms, departments
                }, () => {
                    this.getStudentsForGroupGrading();
                    this.getAllStudents(localStorage.getItem('gradedActivityId'), false, 0, 10);
                    this.getAllStudents(localStorage.getItem('gradedActivityId'), true, 0, 10);
                });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch marks or study types');
            });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
        localStorage.setItem('activeIndex', activeIndex);
    }

    getStudentsForGroupGrading() {
        let obj = {};
        axios.post(`/professor/students/${localStorage.getItem('gradedActivityId')}/false/false/0/0`, { ...obj })
            .then(res => {
                const data = res.data.responseList.map(el => ({
                    ...el,
                    id: el.studentGradedActivityId,
                    studyProgram: el.studyProgramName,
                    studyType: this.state.studyTypes.find(e => e.key === el.studyTypeId).text,
                    grade: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null,
                    passed: !!el.markId
                }));
                let clean = data.filter((arr, index, self) =>
                    index === self.findIndex((t) => (t.firstName === arr.firstName && t.lastName === arr.lastName && t.index === arr.index)));
                this.setState({ allUngradedStudents: clean });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch all students');
            });
    }


    getAllStudents(gradedActivityId, graded) {
        this.setState({ graded: false });
        let obj = {};
        axios.post(`/professor/students/${gradedActivityId}/false/${graded}/0/0`, { ...obj })
            .then(res => {
                const data = res.data.responseList.map(el => ({
                    ...el,
                    id: el.studentGradedActivityId,
                    studyProgram: el.studyProgramName,
                    studyType: this.state.studyTypes.find(e => e.key === el.studyTypeId).text,
                    grade: el.markId ? this.state.marks.find(e => e.key === el.markId).text : null,
                    passed: !!el.markId
                }));
                if (graded) {
                    let clean = data.filter((arr, index, self) =>
                        index === self.findIndex((t) => (t.firstName === arr.firstName && t.lastName === arr.lastName && t.index === arr.index)));
                    this.setState({ gradedStudents: clean, totalPagesGraded: res.data.total });
                } else {
                    let clean = data.filter((arr, index, self) =>
                        index === self.findIndex((t) => (t.firstName === arr.firstName && t.lastName === arr.lastName && t.index === arr.index)));
                    this.setState({ ungradedStudents: clean, totalPagesUngraded: res.data.total }, () => this.setState({ loaded: true }));
                }

                this.setState({ graded: true });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch all students');
            });
    }
    onFinalize() {
        axios.put(`professor/finalize-graded-activity/${localStorage.getItem('gradedActivityId')}`)
            .then(res => {
                toast(<FormattedMessage id="professorInputGrades.toastFinalized" />);
                window.history.go(-1);
            })
            .catch(err => {
                toast(<FormattedMessage id="professorInputGrades.toastFinalizedFailed" />);
            });

    }

    frontFilterData(data, departmentId, studyProgramBasicId, studyTypeId, sortingOption, filterGradedStudent) {
        const enCollator = new Intl.Collator('hr');
        let filterUngradedStudents = [...data];
        let filterGradedStudents = [...data];
        if (filterGradedStudent) {
            if (departmentId) { filterGradedStudents = filterGradedStudents.filter(el => (el.departments[0].id === departmentId)); }
            if (studyProgramBasicId) { filterGradedStudents = filterGradedStudents.filter(el => (el.studyProgramBasicId === studyProgramBasicId)); }
            if (studyTypeId) { filterGradedStudents = filterGradedStudents.filter(el => (el.studyTypeId === studyTypeId)); }
            if (sortingOption === 'firstNameAsc') {
                filterGradedStudents = filterGradedStudents.sort((a, b) => enCollator.compare(a.firstName, b.firstName));
            }
            if (sortingOption === 'firstNameDes') {
                filterGradedStudents = filterGradedStudents.sort((a, b) => enCollator.compare(a.firstName, b.firstName)).reverse();
            }
            if (sortingOption === 'lastNameAsc') {
                filterGradedStudents = filterGradedStudents.sort((a, b) => enCollator.compare(a.lastName, b.lastName));
            }
            if (sortingOption === 'lastNameDes') {
                filterGradedStudents = filterGradedStudents.sort((a, b) => enCollator.compare(a.lastName, b.lastName)).reverse();
            }
            this.setState({ filterGradedStudents });
        } else {
            if (departmentId) { filterUngradedStudents = filterUngradedStudents.filter(el => (el.departments[0].id === departmentId)); }
            if (studyProgramBasicId) { filterUngradedStudents = filterUngradedStudents.filter(el => (el.studyProgramBasicId === studyProgramBasicId)); }
            if (studyTypeId) { filterUngradedStudents = filterUngradedStudents.filter(el => (el.studyTypeId === studyTypeId)); }
            if (sortingOption === 'firstNameAsc') {
                filterUngradedStudents = filterUngradedStudents.sort((a, b) => enCollator.compare(a.firstName, b.firstName));
            }
            if (sortingOption === 'firstNameDes') {
                filterUngradedStudents = filterUngradedStudents.sort((a, b) => enCollator.compare(a.firstName, b.firstName)).reverse();
            }
            if (sortingOption === 'lastNameAsc') {
                filterUngradedStudents = filterUngradedStudents.sort((a, b) => enCollator.compare(a.lastName, b.lastName));
            }
            if (sortingOption === 'lastNameDes') {
                filterUngradedStudents = filterUngradedStudents.sort((a, b) => enCollator.compare(a.lastName, b.lastName)).reverse();
            }
            this.setState({ filterUngradedStudents });
        }

        // let filterItems = ['index', 'firstName', 'lastName', 'name', 'studyProgramBasicName', 'studyTypeId'];
    }

    render() {
        const panes = [
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.notGradedStudents" /> },
                pane: {
                    attached: false,
                    responsive: Responsive,
                    content: (
                        <StudentsWithoutGrades
                            allUngradedStudents={this.state.allUngradedStudents}
                            data={this.state.ungradedStudents}
                            filterData={this.state.filterUngradedStudents}
                            marks={this.state.marks}
                            departments={this.state.departments}
                            studyPrograms={this.state.studyPrograms}
                            sortingOptions={this.state.sortingOptions}
                            studyTypes={this.state.studyTypes.map((e) => ({ ...e, value: { displayName: e.text, id: e.id } }))}
                            totalPages={this.state.totalPagesUngraded}
                            getAllStudents={(gradedActivityId, graded) => this.getAllStudents(gradedActivityId, graded)}
                            getStudentsForGroupGrading={this.getStudentsForGroupGrading}
                            frontFilterData={this.frontFilterData}


                        />
                    )
                }
            },
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.gradedStudents" /> },
                pane: {
                    attached: false,
                    responsive: Responsive,
                    content: (
                        <TabPane as="div" responsive={Responsive}>
                            <StudentsWithGrades
                                data={this.state.gradedStudents}
                                filterData={this.state.filterGradedStudents}
                                marks={this.state.marks}
                                departments={this.state.departments}
                                studyPrograms={this.state.studyPrograms}
                                sortingOptions={this.state.sortingOptions}
                                studyTypes={this.state.studyTypes.map((e) => ({ ...e, value: { displayName: e.text, id: e.id } }))}
                                totalPages={this.state.totalPagesGraded}
                                getAllStudents={(gradedActivityId, graded) => this.getAllStudents(gradedActivityId, graded)}
                                getStudentsForGroupGrading={this.getStudentsForGroupGrading}
                                frontFilterData={this.frontFilterData}
                            />
                        </TabPane>)
                }
            },
            {
                menuItem: { content: <FormattedMessage id="professorInputGrades.externalStudentGrades" /> },
                pane: {
                    attached: false,
                    content: (
                        <TabPane as="div">
                            <ExternalStudentGrades />
                        </TabPane>
                    )
                }
            }
        ];

        if (localStorage.getItem('gradedActivityName') === 'komisijski ispit') {
            return (
                <GradingCommitteeExam />
            );
        }
        return (
            <div>
                <Header as="h1"><FormattedMessage id="professorInputGrades.activeCourse" /></Header>

                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            <Header style={IconHeader} floated="right">
                                <Icon />
                                <Popup
                                    trigger={<Icon
                                        link
                                        circular
                                        basic
                                        floated="right"
                                        name="arrow left"
                                        onClick={() => {
                                            window.history.go(-1);
                                            localStorage.setItem('toHome', true);
                                        }}
                                    />}
                                    content="Nazad"
                                    hideOnScroll
                                    position="top center"
                                />
                            </Header>
                            {localStorage.getItem('courseImplementationName') + ' / ' + localStorage.getItem('gradedActivityName') + ' / ' + localStorage.getItem('date')}
                            <Header.Subheader>
                                <FormattedMessage id="professorStatistics.courseExamDate" />
                            </Header.Subheader>

                        </Header>
                    </Segment>


                    <Segment >
                        {this.state.finalizeCheck ?
                            <div style={{ textAlign: 'center' }}>
                                <Header as="h3">
                                    <FormattedMessage id="professorInputGrades.finalizeCheck" />
                                </Header>
                                {/* <h3><FormattedMessage id="professorInputGrades.finalizeCheck" /></h3> */}
                                <Button.Group >
                                    <Button
                                        basic="true"
                                        color="blue"
                                        onClick={this.onFinalize}
                                    > <FormattedMessage id="common.yes" /></Button>
                                    <Button
                                        basic="true"
                                        color="red"
                                        onClick={() => { this.setState({ finalizeCheck: false }); }}
                                    > <FormattedMessage id="common.no" />

                                    </Button>
                                </Button.Group>

                            </div>
                            : <div>
                                <Header as="h3" textAlign="center">

                                    <Header.Subheader>
                                        <FormattedMessage id="professorInputGrades.finalizeInfo" /> <i><FormattedMessage id="professorInputGrades.finalizeInfo2" /></i>

                                    </Header.Subheader>
                                </Header>
                                <Button
                                    fluid
                                    color="red"
                                    onClick={() => this.setState({ finalizeCheck: true })}
                                ><h3><b><FormattedMessage id="professorInputGrades.finalize" /></b></h3>
                                    {/*  <Random
                                text="FINALIZIRAJ ISPIT!"
                                effect="jump"
                                effectChange={0.3}
                                effectDuration={0.4}
                            /> */}
                                </Button>
                            </div>}

                    </Segment>
                    {this.state.loaded ?
                        <Segment clearing><Tab id="myTab" panes={panes} menu={{ color: 'blue', secondary: true, pointing: true }} renderActiveOnly={false} defaultActiveIndex={0} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} /></Segment>
                        : <Segment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Segment>}
                    <ToastContainer hideProgressBar />
                </Segment.Group>

            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorInputGrades/InputGrades.js